<template>
  <div class="plv-ia-lottery-start">
    <div class="plv-ia__lottery__container">
      <ul class="modal-form plv-ia-modal__center__form">
        <li class="plv-ia-lottery-control">
          <div v-if="!lotteryTemplate" class="plv-ia-lottery-control-template plv-ia-lottery-control-template--choose">
            <p>{{ t('plvIA.lottery.createdSweepstakes') }} <span class="plv-ia-lottery-control-template-btn" @click="goTemplatePage">{{ t('plvIA.lottery.selectActivity') }}</span></p>
          </div>
          <div v-else class="plv-ia-lottery-control-template plv-ia-lottery-control-template--reset">
            <p> <span class="plv-ia-lottery-control-template-name">{{ lotteryTemplate.activityName }}</span> <span class="plv-ia-lottery-control-template-btn" @click="resetTemplate">{{ t('plvIA.lottery.reset') }}</span></p>
          </div>
        </li>
        <!-- 奖品名称 -->
        <li class="plv-ia-modal__form__group">
          <span class="plv-ia-modal__form__label">{{
            t('plvIA.lottery.prizeName')
          }}</span>
          <input
            ref="prizeName"
            v-model="prizeName"
            type="text"
            :maxlength="maxLen.prizeName"
            :placeholder="t('plvIA.lottery.enterPrizeName')"
            :class="[
              'plv-ia-modal__form__input',
              { 'plv-ia-wrong-input': wrongOptions.prizeName }
            ]"
            @click.stop="() => $refs.historyList.listShow()"
            @keyup="wrongOptions.prizeName = false"
          />
          <span
            class="plv-ia__prize__length"
          ><span :class="{ 'plv-ia-err': strLen(prizeName) > maxLen.prizeName }">{{
            strLen(prizeName)
          }}</span>/{{ maxLen.prizeName }}</span>
          <NameHistory
            ref="historyList"
            :history-prize="historyPrizeName"
            @get-prize="getPrize"
          />
        </li>
        <!-- 抽奖模式 -->
        <li class="plv-ia-modal__form__group">
          <span class="plv-ia-modal__form__label">{{
            t('plvIA.lottery.lotteryMode')
          }}</span>
          <div class="plv-ia-modal__form__select">
            <InputSelect
              :options="modeOptions"
              :default-index="modeIndex.toString()"
              :placeholder="t('plvIA.common.enter')"
              @select-index="selectMode"
            />
          </div>
        </li>
        <!-- 抽奖时间 -->
        <li
          v-show="modeIndex === 1"
          class="plv-ia-modal__form__group"
        >
          <span class="plv-ia-modal__form__label">{{
            t('plvIA.lottery.luckyTime')
          }}</span>
          <el-date-picker
            v-model="luckyTime"
            style="width: 320px;"
            type="datetime"
            placeholder="请选择时间"
            :popper-class="isRestrictedWindow ? 'plv-ia-lottery-date-picker' : ''"
          />
        </li>
        <!-- 参与用户 -->
        <li class="plv-ia-modal__form__group">
          <span class="plv-ia-modal__form__label">{{
            t('plvIA.lottery.participatingUsers')
          }}</span>
          <div class="plv-ia-modal__form__select">
            <InputSelect
              :options="lotteryRangeData"
              :default-index="lotteryRangeIndex"
              :placeholder="t('plvIA.common.enter')"
              @select-index="selectRange"
            />
          </div>
        </li>
        <!-- 中奖人数 -->
        <li class="plv-ia-modal__form__group">
          <span class="plv-ia-modal__form__label">{{
            t('plvIA.lottery.winnersNum')
          }}</span>
          <div class="plv-ia-modal__form__input__sm">
            <InputSelect
              ref="numberSelect"
              :options="rangeNumber"
              :default-value="amount"
              :max-winners-digit="maxWinnersDigit"
              :max-winners="maxWinners"
              :could-input="true"
              width="320px"
              :placeholder="t('plvIA.lottery.enterPositiveInteger')"
              @check-input="checkNumber"
            />
          </div>
        </li>
        <!-- 预设中奖开关 -->
        <li
          v-if="!isSubsidiaryRoom"
          class="plv-ia-modal__form__group plv-ia-modal__form__group--min"
        >
          <span class="plv-ia-modal__form__label">{{
            t('plvIA.lottery.presetWinning')
          }}</span>
          <span
            :class="[
              'plv-ia-modal__switch__btn',
              { 'plv-ia-modal__switch__btn__off': switchOff }
            ]"
            @click="switchOff = !switchOff"
          ></span>
        </li>
        <!-- 预设中奖名单 -->
        <li v-show="!switchOff" class="plv-ia-modal__form__group">
          <span class="plv-ia-modal__form__label"></span>
          <div class="plv-ia__search__group fast-search">
            <input
              v-model.trim="searchUser"
              type="text"
              :placeholder="t('plvIA.lottery.quickSearch')"
              class="plv-ia-modal__form__input plv-ia-modal__form__input__preset"
              @keyup="searchOnlineList"
            />
            <i class="plv-ia-search__icon"></i>
          </div>
        </li>
        <li v-show="!switchOff">
          <div class="plv-ia__user__search__list">
            <LotteryList
              ref="lotteryList"
              :search-list="searchList"
              :amount="Number(amount)"
              :lang="lang"
              @clear-search-input="searchUser = ''"
              @update-preset="updatePresetList"
            />
          </div>
        </li>
      </ul>
      <!-- 更多设置 -->
      <div v-show="!lotteryTemplate" class="plv-ia__lottery__aside__right">
        <div>
          <div class="plv-ia__lottery-collect-handle">
            <div>
              <span class="plv-ia-lottery__msg__name">{{ t('plvIA.lottery.collection') }}
              </span>
              <span
                :class="[
                  'plv-ia-modal__switch__btn',
                  { 'plv-ia-modal__switch__btn__off': !collectSwitch}
                ]"
                @click="setCollectSwitch"
              ></span>
            </div>
            <div class="plv-ia__lottery-add-option" v-show="collectSwitch">
              <span>{{ t('plvIA.lottery.addCollectOption') }}</span>
              <div class="plv-ia__lottery-add-option-model">
                <ul class="plv-ia__lottery-add-option-item">
                  <li v-for="(item, index) in collectBtnList"
                      :class="{'plv-ia__lottery-add-option-item--disable': item.addStatus || item.disable}"
                      :key="index"
                      @click="collectBtnControls('add', item.type)">
                    {{ item.label ||  t(item.langLabel)}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <ul v-show="collectSwitch" class="plv-ia-lottery__msg__list__container">
            <li v-show="collectBtnList.userName.addStatus">
              <span class="plv-ia-lottery__msg__name">{{
                t('plvIA.lottery.name')
              }}</span>
              <span class="plv-ia-lottery__msg__input">{{
                t('plvIA.lottery.enterName')
              }}</span>
              <div class="plv-ia-lottery__options__control">
                <span class="plv-ia-lottery__options__control-requiredText">{{ t('plvIA.lottery.requiredText') }}</span>
                <span
                  :class="[
                    'plv-ia-modal__switch__btn',
                    { 'plv-ia-modal__switch__btn__off': !collectBtnList.userName.required }
                  ]"
                  @click="collectBtnList.userName.required = !collectBtnList.userName.required"
                ></span>
                <span
                  class="plv-ia-lottery__options__control__delete"
                  @click="collectBtnControls('del', collectBtnList.userName.type)"
                ></span>
              </div>
            </li>
            <li v-show="collectBtnList.userPhone.addStatus">
              <span class="plv-ia-lottery__msg__name">{{
                t('plvIA.lottery.phoneNum')
              }}</span>
              <span class="plv-ia-lottery__msg__input">{{
                t('plvIA.lottery.enterPhoneNum')
              }}</span>
              <div class="plv-ia-lottery__options__control">
                <span class="plv-ia-lottery__options__control-requiredText">{{ t('plvIA.lottery.requiredText') }}</span>
                <span
                  :class="[
                    'plv-ia-modal__switch__btn',
                    { 'plv-ia-modal__switch__btn__off': !collectBtnList.userPhone.required }
                  ]"
                  @click="collectBtnList.userPhone.required = !collectBtnList.userPhone.required"
                ></span>
                <span
                  class="plv-ia-lottery__options__control__delete"
                  @click="collectBtnControls('del', collectBtnList.userPhone.type)"
                ></span>
              </div>
            </li>
            <li
              v-for="(item, index) in receiveInfo"
              :key="index"
              class="plv-ia-custom__list__input"
            >
              <span class="plv-ia-lottery__msg__name">{{
                t('plvIA.lottery.custom')
              }}</span>
              <span class="plv-ia-lottery-collection-field">
                <input
                  ref="field"
                  v-model="item.field"
                  :class="{
                    'plv-ia-wrong-input': wrongOptions.custom[index].field
                  }"
                  :placeholder="t('plvIA.lottery.title')"
                  type="text"
                  :maxlength="maxLen.collectionField"
                  @keyup="wrongOptions.custom[index].field = false"
                />
                <span
                  class="plv-ia-lottery-collection-inputlen"
                ><span
                  :class="{
                    'plv-ia-err':
                      strLen(item.field) > maxLen.collectionField
                  }"
                >{{ strLen(item.field) }}</span>/{{ maxLen.collectionField }}</span>
              </span>
              <span class="plv-ia-lottery-collection-tips">
                <input
                  ref="tips"
                  v-model="item.tips"
                  type="text"
                  :maxlength="maxLen.collectionTips"
                  :class="{
                    'plv-ia-wrong-input': wrongOptions.custom[index].tips
                  }"
                  :placeholder="t('plvIA.lottery.enterDescription')"
                  @keyup="wrongOptions.custom[index].tips = false"
                />
                <span
                  class="plv-ia-lottery-collection-inputlen"
                ><span
                  :class="{
                    'plv-ia-err': strLen(item.tips) > maxLen.collectionTips
                  }"
                >{{ strLen(item.tips) }}</span>/{{ maxLen.collectionTips }}</span>
              </span>
              <div class="plv-ia-lottery__options__control">
                <span class="plv-ia-lottery__options__control-requiredText">{{ t('plvIA.lottery.requiredText') }}</span>
                <span
                  :class="[
                    'plv-ia-modal__switch__btn',
                    { 'plv-ia-modal__switch__btn__off': !item.required }
                  ]"
                  @click="item.required = !item.required"
                ></span>
                <span
                  class="plv-ia-lottery__options__control__delete"
                  @click="optionsControls('del', index)"
                ></span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="plv-ia__lottery-btn-group" v-if="lotteryCardList.length > 0">
        <button class="plv-ia-lottery-btn plv-ia-lottery-btn--back" style="margin-right: 16px;" @click="backPage">
          {{ t('plvIA.lottery.back') }}
        </button>
        <button class="plv-ia-lottery-btn" @click="startLottery">
          {{ t('plvIA.common.confirm') }}
        </button>
      </div>
      <div class="plv-ia__lottery-btn-group" v-else>
        <button class="plv-ia-lottery-btn" @click="startLottery">
          {{ t('plvIA.lottery.start') }}
        </button>
      </div>
    </div>
    <c-confirm
      ref="exceedConfirm"
      :tips="t('plvIA.lottery.exceedOnline')"
      :ensure-txt="t('plvIA.common.confirm')"
      :cancel-txt="t('plvIA.common.cancel')"
      @ensure="handleEnsureExceedConfirm"
      @cancel="handleCancelExceedConfirm"
    />
  </div>
</template>

<script>
import { strLen } from '@polyv/utils/src/string';
import { debounce } from 'lodash-es';
import Locale from '@/mixins/locale';
import commonMixin from '../app-mixin';
import NameHistory from '@/apps/lottery-new/component/NameHistory';
import InputSelect from '../../components/inputSelect';
import LotteryList from './LotteryList';
import PopupConfirm from '../../components/popup/Confirm';

const maxLen = {
  prizeName: 40,
  collectionField: 12,
  collectionTips: 30
};
export default {
  props: {
    core: Object,
    /**
     * 最大中奖人数位数。
     * 如有设置 maxWinners 为非 0 整数时则忽略 maxWinnersDigit 。
     */
    maxWinnersDigit: {
      type: Number,
      default: 3
    },
    isRestrictedWindow: {
      type: Boolean,
      default: true
    },
    /**
     * 最大中奖人数。
     * 如有设置 maxWinners 为非 0 整数时则忽略 maxWinnersDigit 。
     */
    maxWinners: {
      type: Number,
      default: 0,
    },
    /** 是否开启多房间 */
    isSubsidiaryRoom: {
      type: Boolean,
      default: false
    },
    // 抽奖历史名称
    historyPrizeName: {
      type: Array,
      default: () => {
        return [];
      }
    },
    lotteryTemplate: {
      type: Object
    },
    lotteryCardList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  mixins: [Locale, commonMixin],
  components: {
    NameHistory,
    InputSelect,
    LotteryList,
    'c-confirm': PopupConfirm
  },
  data() {
    return {
      maxLen,
      modeIndex: 0, // 0： 即时抽奖 1： 倒计时抽奖
      prizeName: '', // 奖品名称
      luckyTime: new Date(), // 抽奖时间
      modeOptions: [], // 抽奖模式 即时抽奖 倒计时抽奖
      lotteryRange: 'notWinning', // 抽奖范围
      lotteryRangeData: [], // 参与用户下拉选项
      lotteryRangeIndex: 0, // 参与用户下拉选项index
      amount: '', // 中奖人数
      switchOff: true, // 开启预设中奖
      searchList: [], // 查询用户列表
      presetList: [], // 预设中奖名单
      searchUser: '',
      wrongOptions: {
        prizeName: false,
        amount: false,
        custom: [
          {
            field: false,
            tips: false
          }
        ]
      },
      showMore: false,
      collectSwitch: true, // 是否收集用户信息
      collectBtnList: {
        userName: {
          type: 'userName',
          langLabel: 'plvIA.lottery.userName',
          addStatus: true,
          required: true,
        },
        userPhone: {
          type: 'userPhone',
          langLabel: 'plvIA.lottery.userPhone',
          addStatus: true,
          required: true
        },
        custom: {
          langLabel: 'plvIA.lottery.customOption',
          type: 'custom',
          disable: false
        }
      },
      receiveInfo: [], // 自定义用户信息
    };
  },
  computed: {
    rangeNumber() {
      const range = [];
      for (let i = 1; i <= 10; i++) {
        range.push({ label: i, value: i });
      }
      return range;
    }
  },
  watch: {
    core: {
      type: Object
    },
    lang: {
      handler() {
        this.initOptions();
      },
      immediate: true
    },
    searchUser() {
      this.searchOnlineList();
    },
    lotteryTemplate(temp) {
      if (!temp) return;
      this.prizeName = temp.prizeName;
      this.amount = temp.amount;
    }
  },
  // mounted() {
  //   this.initOptions();
  // },
  methods: {
    strLen,
    goTemplatePage() {
      this.$emit('change-page', { page: 'lotteryTemplate' });
    },
    resetTemplate() {
      this.prizeName = '';
      this.amount = '';
      this.modeIndex = 0;
      this.lotteryRangeIndex = 0;
      this.lotteryRange = this.lotteryRangeData[this.lotteryRangeIndex].value;
      this.$emit('reset-template');
    },
    getPrize(val) {
      if (val) {
        this.prizeName = val;
        this.wrongOptions.prizeName = false;
      }
    },

    // 初始化select选项中英文 文案
    initOptions() {
      this.lotteryRangeData = [
        {
          label: this.t('plvIA.lottery.missedUsers'),
          value: 'notWinning'
        },
        {
          label: this.t('plvIA.lottery.allOnlineUsers'),
          value: 'all'
        },
      ];
      this.modeOptions = [
        {
          label: this.t('plvIA.lottery.immediate'),
          value: 0
        },
        {
          label: this.t('plvIA.lottery.timed'),
          value: 1
        }
      ];
    },

    // 选择抽奖模式
    selectMode(index) {
      this.modeIndex = index;
    },

    // 计算毫秒数
    calcDelayTime() {
      return new Date(this.luckyTime).getTime() - Date.now();
    },

    selectRange(index) {
      this.lotteryRange = this.lotteryRangeData[index].value;
      this.lotteryRangeIndex = index;
    },

    // 检查纯数字
    checkNumber(value) {
      if (Number(value) === 0) {
        this.wrongOptions.amount = true;
        this.$refs.numberSelect.setWrong();
        this.amount = '';
        return;
      }
      this.amount = value;
      this.wrongOptions.amount = false;
    },

    // 搜索在线昵称
    searchOnlineList: debounce(async function() {
      const { searchUser, lotteryRange } = this;
      if (searchUser && searchUser !== '') {
        this.searchList = await this.core.searchUserList(searchUser, lotteryRange);
      } else {
        this.searchList = [];
      }
    }),

    // 更新预设列表
    updatePresetList(ary) {
      this.presetList = [];
      ary.forEach(item => {
        this.presetList.push({
          userId: item.userId,
          nickname: item.nick
        });
      });
    },

    // 开始抽奖
    // eslint-disable-next-line sonarjs/cognitive-complexity
    async startLottery() {
      //   const sessionId = await utils.getSessionId(this.roomId);
      const { lotteryRange, prizeName, amount, receiveInfo, presetList, lotteryTemplate } = this;
      let fullInfo = [];
      // 模板获取 收集用户信息
      const options = {
        lotteryRange,
        prizeName: prizeName,
        amount,
        presetList: [],
        ignoreOnline: true,
        hasCollect: this.collectSwitch ? 'Y' : 'N',
      };
      if (!this.switchOff) {
        options.presetList = presetList;
      }
      // 模板判断
      if (lotteryTemplate) {
        options.id = lotteryTemplate.id;
        const infoArray = lotteryTemplate.lotteryCondition === 'none' ? lotteryTemplate.receiveInfo : lotteryTemplate.formInfo;
        if (infoArray instanceof Array) {
          infoArray.forEach(item => {
            fullInfo.push(item);
          });
        }
        // 旧数据可能存在null情况
        if (!infoArray || infoArray.length === 0) {
          options.hasCollect = 'N'; // 判断没有信息收集，设为false
        }
        console.info('lottery start', options);
      } else if (this.collectSwitch) {
        if (this.collectBtnList.userName.addStatus) {
          fullInfo.push({
            type: this.collectBtnList.userName.type,
            field: this.t('plvIA.lottery.name'),
            tips: this.t('plvIA.lottery.enterName'),
            required: this.collectBtnList.userName.required
          });
        }
        if (this.collectBtnList.userPhone.addStatus) {
          fullInfo.push({
            type: this.collectBtnList.userPhone.type,
            field: this.t('plvIA.lottery.phoneNum'),
            tips: this.t('plvIA.lottery.enterPhoneNum'),
            required: this.collectBtnList.userPhone.required
          });
        }
        fullInfo = fullInfo.concat(receiveInfo);
        if (fullInfo.length === 0) {
          this.$iaMessage.default('请添加要收集的信息');
          return;
        }
      }
      options.receiveInfo = fullInfo;

      // 判断抽奖模式是 0即时抽奖 1定时抽奖
      if (this.modeIndex === 1) {
        options.lotteryTime = new Date(this.luckyTime).getTime();
        options.lotteryMode = 'wait';
      } else {
        options.lotteryMode = 'immediate';
      }
      const rightOptions = this.checkOptions(options);
      if (!rightOptions) return;
      this.options = options;
      if ((this.lotteryTemplate && this.lotteryTemplate.lotteryCondition !== 'none') || await this.checkedUserCount()) {
        this.$emit('create-lottery', this.options);
      }
    },

    toggleExceedConfirm(toShow) {
      if (toShow) {
        this.$refs.exceedConfirm.show();
      } else {
        this.$refs.exceedConfirm.hide();
      }
    },

    // 检查提交参数是否合规
    checkOptions(options) {
      const { prizeName, amount, receiveInfo, delayTime } = options;
      if (!prizeName || prizeName === '' || strLen(prizeName) > this.maxLen.prizeName) {
        this.wrongOptions.prizeName = true;
        this.optionFocus(this.$refs.prizeName);
        return false;
      }
      if (delayTime < 0) {
        this.$iaMessage.default('抽奖时间不能小于当前时间');
        return false;
      }
      if (!amount || amount === '' || amount === 0) {
        this.wrongOptions.amount = true;
        this.$refs.numberSelect.setWrong();
        return false;
      }

      let wrongOptions = false;
      let userIndex = 0; //  记录含有姓名和手机号选项
      // 校验
      for (let index = 0; index < receiveInfo.length; index++) {
        // 获取真实下标 需要减去姓名和手机号选项index
        const realIndex = index - userIndex;
        const item = receiveInfo[index];
        if (item.type) {
          userIndex++;
          continue;
        }
        if (
          item.field === '' ||
          strLen(item.field) > this.maxLen.collectionField
        ) {
          this.fieldOrTipsFocus(realIndex, true);
          this.wrongOptions.custom[realIndex].field = true;
          wrongOptions = true;
          break;
        }
        if (
          item.tips === '' ||
          strLen(item.tips) > this.maxLen.collectionTips
        ) {
          this.fieldOrTipsFocus(realIndex, false);
          this.wrongOptions.custom[realIndex].tips = true;
          wrongOptions = true;
          break;
        }
      }
      return !wrongOptions;
    },

    // 检查聊天室的人数
    async checkedUserCount() {
      const { lotteryRange } = this;
      try {
        const res = await this.core.checkedUserCount(lotteryRange);
        if (res < this.amount) {
          this.toggleExceedConfirm(true);
          return;
        }
        this.wrongOptions.amount = false;
        this.totalAccount = res;
        return true;
      } catch (error) {
        throw new Error(error);
      }
    },

    fieldOrTipsFocus(realIndex, isField) {
      const key = isField ? 'field' : 'tips';
      if (this.$refs.field[realIndex]) {
        this.optionFocus(this.$refs[key][realIndex]);
      } else {
        this.showMore = true;
        this.$nextTick(() => {
          this.optionFocus(this.$refs[key][realIndex]);
        });
      }
    },

    optionFocus(refs) {
      this.$nextTick(() => refs.focus());
    },

    // 增加、删除自定义选项
    optionsControls(type, index) {
      if (type === 'add') {
        if (this.receiveInfo.length === 3) return;
        this.receiveInfo.push({
          field: '',
          tips: '',
          required: false,
        });
        this.wrongOptions.custom.push({
          field: false,
          tips: false
        });
        if (this.receiveInfo.length === 3) this.collectBtnList.custom.disable = true;
      } else {
        this.receiveInfo.splice(index, 1);
        this.wrongOptions.custom.splice(index, 1);
        this.collectBtnList.custom.disable = false;
        this.checkCollectListLength();
      }
    },

    collectBtnControls(type, collectType, index) {
      if (collectType === 'custom') {
        this.optionsControls(type, index);
      } else {
        // 添加姓名或者手机号
        if (type === 'add') {
          const addStatus = this.collectBtnList[collectType].addStatus;
          if (!addStatus) {
            this.collectBtnList[collectType].addStatus = true;
          }
        } else if (type === 'del') {
          this.collectBtnList[collectType].addStatus = false;
          this.checkCollectListLength();
        }
      }
    },

    // 检查如果没有信息收集项，将中奖信息采集按钮关闭
    checkCollectListLength() {
      // 判断姓名和手机号是否收集
      if (this.receiveInfo.length > 0) {
        return;
      }
      // 判断姓名和手机号是否收集
      if (!(this.collectBtnList.userName.addStatus || this.collectBtnList.userPhone.addStatus)) {
        this.collectSwitch = false;
      }
    },

    setCollectSwitch() {
      this.collectSwitch = !this.collectSwitch;
      // 开启信息收集开关后，没有收集项，默认显示手机和姓名
      const defaultCollect = this.collectSwitch && !this.collectBtnList.userPhone.addStatus && !this.collectBtnList.userName.addStatus && this.receiveInfo.length === 0;
      if (defaultCollect) {
        this.collectBtnList.userName.addStatus = true;
        this.collectBtnList.userPhone.addStatus = true;
      }
    },

    handleEnsureExceedConfirm() {
      this.toggleExceedConfirm(false);
      this.wrongOptions.amount = false;
      this.$emit('create-lottery', this.options);
    },

    handleCancelExceedConfirm() {
      this.toggleExceedConfirm(false);
      this.wrongOptions.amount = true;
    },

    backPage() {
      this.$emit('change-page', { page: 'lotteryCardList' });
    },
    reset() {
      this.resetTemplate();
    }

  }
};
</script>

<style lang="scss">

body[data-lang='en'] {
  .plv-ia__lottery-collect-handle {
    width: 450px;
  }
}
.plv-ia-lottery-start {
  display: flex;
  justify-content: center;
  padding-top: 24px;
  margin-left: 60px;
  .plv-ia__lottery__container {
    min-width: 550px;
  }
  .plv-ia-lottery-btn {
    min-width: 90px;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    background: #2196f3;
    font-size: 14px;
    color: #ffffff;
    border-radius: 18px;
    border: none;
    outline: none;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.9;
    }
  }
  .plv-ia__lottery-collect-handle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 430px;
  }
  .plv-ia__lottery-add-option:hover {
    .plv-ia__lottery-add-option-model {
      display: block;
    }
  }
  .plv-ia__lottery-add-option {
    position: relative;
    display: inline-block;
    height: 25px;
    line-height: 25px;
    padding: 0;
    .plv-ia__lottery-add-option-model {
      display: none;
      position: absolute;
      top: 25px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      padding: 13px 24px;
      z-index: 100;
      background: white;
      width: 120px;
      box-sizing: border-box;
      border: 0.5px solid #DCDCDC;
      border-radius: 2px;
      box-shadow: 0 -5px 5px -3px rgba(0, 0, 0, 0.1), 0 -8px 10px 1px rgba(0, 0, 0, 0.06);
    }
    li + li {
      margin-top: 20px;
    }
    li:hover {
      cursor: pointer;
      color: #3796F3;
      font-size: 14px;
    }
    .plv-ia__lottery-add-option-item--disable {
      color: #aeaeae !important;
      cursor: default !important;
    }
  }
}
.plv-ia-modal__form__group {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
  text-align: left;
  font-size: 14px;
  &--branch {
    justify-content: flex-end;
    margin-bottom: 12px;
    font-size: 14px;
    color: #2196f3;
    .plv-icon-info-circle {
      font-size: 14px;
      margin-right: 8px;
    }
  }
  > span:nth-child(1) {
    display: inline-block;
    width: 100px;
    margin-right: 8px;
    line-height: 0;
    vertical-align: middle;
    text-align: center;
    font-size: 14px;
  }

  > input {
    width: 320px;
    height: 40px;
    border: 1px solid rgba(207, 216, 220, 1);
    padding: 0 8px;
    vertical-align: middle;
    font-size: 14px;
    border-radius: 2px;
    outline: none;
    color: #333;

    &:hover,
    &:active {
      border: 1px solid #2196f3;
    }
  }

  .plv-ia-modal__form__input {
    padding-right: 50px;
  }

  .plv-ia__prize__length {
    position: absolute;
    right: 8px;
    font-size: 12px;
    color: #9e9e9e;
  }
}

.plv-ia-modal__form__group--min {
  height: 20px;
  line-height: 20px;
}
.plv-ia-lottery-control-template {
  margin-bottom: 24px;
  text-align: left;
  color: #333333;
  .plv-ia-lottery-control-template-btn {
    color: #2196F3;
    cursor: pointer;
  }
}
.plv-ia-lottery-control-template--reset {
  p {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .plv-ia-lottery-control-template-name {
    font-weight: 500;
    font-size: 18px;
  }
}
.plv-ia__lottery-btn-group {
  .plv-ia-lottery-btn--cancel {
    color: #666666 !important;
    border: 1px solid #EBEEF5;
  }
}

.plv-ia-modal__center__form {
  position: relative;
  text-align: center;

  .plv-ia-modal__form__group {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 20px;
    text-align: left;
    font-size: 14px;
    &--branch {
      justify-content: flex-end;
      margin-bottom: 12px;
      font-size: 14px;
      color: #2196f3;
      position: relative;
      height: 16px;
      width: 430px;
    }
    > span:nth-child(1) {
      display: inline-block;
      width: 100px;
      margin-right: 8px;
      line-height: 0;
      vertical-align: middle;
      text-align: right;
      font-size: 14px;
    }

    > input {
      width: 320px;
      height: 40px;
      border: 1px solid rgba(207, 216, 220, 1);
      padding: 0 8px;
      vertical-align: middle;
      font-size: 14px;
      border-radius: 2px;
      outline: none;
      color: #333;

      &:hover,
      &:active {
        border: 1px solid #2196f3;
      }
    }

    .plv-ia-modal__form__input {
      padding-right: 50px;
    }

    .plv-ia__prize__length {
      position: absolute;
      left: 390px;
      font-size: 12px;
      display: inline-block;
      width: 40px;
      color: #9e9e9e;
    }
  }

  .plv-ia-modal__form__group--min {
    height: 20px;
    line-height: 20px;
  }

  .plv-ia-modal__form__input,
  .plv-ia-modal__form__select {
    width: 320px;
    height: 40px;
    padding-left: 8px;
    background-color: #fff;
    display: inline-block;
  }
  .plv-ia-modal__form__select {
    padding-left: 0;
    vertical-align: middle;
    border: none;
  }

  .plv-ia-modal__form__input__preset {
    padding-left: 8px;
    vertical-align: middle;
    outline: none;
    border: 1px solid #cfd8dc;
    font-size: 14px;
    &:hover,
    &:active {
      border: 1px solid #2196f3;
    }
  }

  .plv-ia-modal__form__input__sm {
    width: 320px;
    height: 40px;
    display: inline-block;
    vertical-align: middle;
  }
}

.plv-ia-lottery-collection-inputlen {
  position: absolute;
  right: 0;
  top: 0;
  line-height: 40px;
  width: 40px;
  text-align: right;
  padding-right: 4px;
  font-size: 12px;
  color: #9e9e9e;
}

.plv-ia__search__group {
  position: relative;
}

.fast-search {
  width: 320px;
  margin-left: 0 !important;

  .plv-ia-search__icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background: url(./images/icon-search.png) center no-repeat;
  }
}

.plv-ia__user__search__list {
  padding-left: 107px;
  max-height: 120px;
  overflow: auto;
}

.plv-ia__lottery__aside__right {
  line-height: 18px;
  > span {
    position: relative;
    width: 70px;
    cursor: pointer;
    color: #2096f3;
    font-size: 14px;
    text-align: center;
    flex-shrink: 0;

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.9;
    }
  }

  .plv-ia-lottery__msg__input {
    width: 320px;
    color: #aeaeae;
    padding: 0 8px;
    display: inline-block;
    line-height: 38px;
    border: 1px solid #cfd8dc;
    border-radius: 2px;
    background: #e9ecee;
  }

  > div > p {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
    color: #2c2c2c;
    font-size: 14px;

    > span {
      color: #2196f3;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 0.9;
      }
    }

    .lottery-add-disabled {
      cursor: not-allowed;
      color: #9e9e9e;
    }
  }

  .plv-ia-lottery__msg__list__container {
    margin-top: 20px;

    > li {
      width: 100%;
      margin-bottom: 20px;
      display: flex;
      position: relative;
      align-items: center;
    }

    > li:last-child {
      margin-bottom: 0;
    }

    .plv-ia-lottery__options__control {
      display: flex;
      align-items: center;
      line-height: 40px;
      font-size: 14px;
      padding-left: 8px;
      position: unset;
      color: inherit;

      .plv-ia-lottery__options__control-requiredText {
        margin-right: 7px;
      }
      .plv-ia-lottery__options__control__delete {
        margin-left: 17px;
        display: inline-block;
        width: 28px;
        height: 28px;
        background-image: url('./images/icon-recycle.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        &:active {
          opacity: 0.9;
        }
      }
    }
    .plv-ia-custom__list__input {
      & > input {
        &:hover,
        &:active {
          border: 1px solid #2196f3;
        }
      }
    }
  }

  .plv-ia-lottery__msg__name {
    width: 100px;
    height: 40px;
    margin-right: 6px;
    line-height: 40px;
    font-size: 14px;
    color: #2c2c2c;
    flex-shrink: 0;
    text-align: right;
  }

  @mixin collectionInput {
    height: 40px;
    position: relative;

    input {
      width: 100%;
      outline: none;
      line-height: 38px;
      padding: 0 8px;
      padding-right: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(224, 224, 224, 1);
      border-radius: 2px;
    }
  }

  .plv-ia-lottery-collection-field {
    @include collectionInput;
    width: 100px;
    margin-right: 8px;
  }

  .plv-ia-lottery-collection-tips {
    @include collectionInput;
    width: 212px;
  }
}

.plv-ia-lottery input[type='text'] {
  color: #333;
  font-size: 14px;

  &::-webkit-input-placeholder {
    color: #9e9e9e;
  }
  &.plv-ia-wrong-input {
    border: 1px solid #ff5722 !important;
    background: #ffe9e9 !important;
    &::-webkit-input-placeholder {
      color: #333 !important;
    }
  }
}

.p-wrong-input::-webkit-input-placeholder {
  color: #333 !important;
}

.plv-ia-modal__switch__btn {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 20px;
  margin-top: -1px;
  border-radius: 16px;
  background: #2096f3;
  cursor: pointer;
  vertical-align: middle;
  &:before {
    content: '';
    position: absolute;
    top: 2px;
    right: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
  }
}

.plv-ia-modal__switch__btn__off {
  background-color: #ccc;

  &:before {
    left: 2px;
    right: auto;
  }
}
</style>
